import React, { useMemo } from 'react'
import { AppointmentCtaLocation, trackAppointmentModalOpened } from '../../Utils/Analytics';
import { Button } from './Button';
import { TrendingFlatOutlined } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { AppState } from '../../Redux/Models';
import { WindowSizes } from "../../Redux/Models/Utility/WIndowSizes";
import { useSelector } from 'react-redux';
import { ToggleAppointmentModal } from '../../Redux/Actions';
export interface RequestAppointmentButtonProps {
  eventTag?: string;
  onClick?: (e?: any) => any;
  theme?: "callToActionBlack" | "callToActionWhite";
  style?: any;
  ctaLocation?: AppointmentCtaLocation;
}

export const RequestAppointmentButton = (props: RequestAppointmentButtonProps) => {
  const dispatch = useDispatch();
  const appSize = useSelector((s: AppState) => s.utility.appWindowSize)
  const handleClick = (e: any) => {
    dispatch(ToggleAppointmentModal(true));
    trackAppointmentModalOpened(props.ctaLocation ?? 'page_hero');
    props.onClick && props.onClick();
  }

  const buttonStyles = useMemo(() => {
    switch (appSize) {
      case WindowSizes.mobile:
      case WindowSizes.smallMobile:
      case WindowSizes.tinyMobile: return { fontSize: 15, padding: '8px 16px' }
      default: return { fontSize: 20, padding: '10px 30px' }
    }
  }, [appSize])

  return (
    <Button
      // @ts-ignore
      IconComponent={({ style, ...props }) => <TrendingFlatOutlined {...props} style={{ ...style, fontSize: 30 }} />}
      theme={props.theme ? props.theme : "callToActionBlack"}
      onClick={handleClick}
      containerStyle={{ padding: buttonStyles.padding, zIndex: 1, borderWidth: '3px', ...props.style }}
      labelStyle={{ fontSize: buttonStyles.fontSize }}
    >
      Request an Appointment
    </Button>
  )
}
